import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../lib/axios";

// Normalize phone to ensure consistent format
const normalizePhone = (phone) => {
    if (!phone) return null;
    return phone.replace(/^\+/, "");
};

export const fetchChat = createAsyncThunk(
  "chat/fetchChat",
  async ({ phone, page = 0, limit = 15, projectId }, { rejectWithValue }) => {
    try {
      const normalizedPhone = normalizePhone(phone);
      if (!normalizedPhone) return rejectWithValue("Valid phone number is required");

      const searchParams = new URLSearchParams({
        skip: String(page * limit),
        limit: String(limit),
      });

      if (projectId) {
        searchParams.append('projectId', projectId);
      }

      const url = `/api/chat/${normalizedPhone}?${searchParams.toString()}`;
      const res = await api.get(url);

      return res.data.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err?.message);
    }
  }
);

// FIXED: Use /api/chat endpoint with projectId filter
export const fetchAllChats = createAsyncThunk(
  "chat/fetchAllChats",
  async ({ projectId }, { rejectWithValue }) => {
    try {
      if (!projectId) {
        return rejectWithValue("Project ID is required");
      }
      
      const res = await api.get(`/api/chat?projectId=${projectId}`);
      return res.data.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err?.message);
    }
  }
);